"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pageTwo = void 0;
exports.pageTwo = () => ({
    content: [
        {
            style: 'tableText',
            stack: [
                '10 Financial Blvd Anderson',
                'Greenvill, SC 29621',
                'Phone: 838-449-2940',
                'NPI: 1265585541,  DEA#: bf8920983,  Licesnse #: SC 874',
                { text: 'Supervising Provider: Flynn, Amanda DO', bold: true },
                'NPI: 1265585541,  DEA#: bf8920983,  Licesnse #: SC 874',
            ],
        },
        {
            style: 'tableText',
            columns: [
                {
                    width: '*',
                    style: { alighnment: 'center' },
                    // Make this a stack
                    text: [
                        'Patient Name: A, Abbie',
                        '\nAddress: Some Street, SC, 92068',
                        '\nDOB: 08/22/1958',
                        '\nHome Phone: (714) 733-3701',
                    ],
                },
                {
                    width: '*',
                    text: [
                        'Written: Aug 30, 2018',
                    ],
                },
            ],
            columnGap: 50,
        },
        {
            style: 'tableText',
            columns: [
                {
                    width: '*',
                    text: 'RX LOGO',
                },
                {
                    width: '*',
                    text: 'barcode and number',
                },
            ],
        },
        {
            style: 'drugInfo',
            stack: [
                'Bupivilog Kit',
                '1 KIT in 1 CARTON (76420-720-01) * 1 mL in 1 VIAL, SINGLE-DOSE * .9 mL in 1 POUCH * 10 mL in 1 VIAL, SINGLE-DOSE',
                'Sig:: in ofice use only',
                'Days Supply: 1',
            ],
        },
        {
            stack: [
                {
                    style: 'prescriberAgent',
                    text: '                                                                     DO',
                    absolutePosition: { x: 350, y: 350 },
                },
                {
                    style: 'description',
                    text: 'Prescriber Agent',
                    absolutePosition: { x: 250, y: 365 },
                },
            ],
        },
        {
            stack: [
                {
                    style: 'prescriberAgent',
                    text: '                                                                                 ',
                    absolutePosition: { x: 275, y: 400 },
                },
                {
                    style: 'description',
                    text: 'Dispense As Written',
                    absolutePosition: { x: 140, y: 415 },
                },
            ],
        },
        {
            stack: [
                {
                    style: 'prescriberAgent',
                    text: '                                                        ',
                    absolutePosition: { x: 450, y: 400 },
                },
                {
                    style: 'description',
                    text: 'Substitution Permissible',
                    absolutePosition: { x: 345, y: 415 },
                },
            ],
        },
    ],
    styles: {
        tableText: {
            fontSize: 8,
            bold: false,
            margin: [-20, 15, 0, 0],
            alignment: 'center',
        },
        drugInfo: {
            fontSize: 10,
            bold: true,
            margin: [0, 40, 0, 0],
            alignment: 'center',
        },
        prescriberAgent: {
            fontSize: 10,
            // alignment: 'center',
            decoration: 'underline',
            decorationStyle: 'solid',
            decorationColor: 'black',
        },
        description: {
            // alignment: 'center',
            fontSize: 8,
        },
        dispenseAsWritten: {
            // alignment: 'center',
            decoration: 'underline',
            decorationStyle: 'solid',
            decorationColor: 'black',
        },
    },
});



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/orders/modules/pdfs/secondPage.ts
// module id = 2731
// module chunks = 0 1